// extracted by mini-css-extract-plugin
export default {"menuContainer":"AppSideMenu_menuContainer__h2h+E"};